import { GAME_CONSTANTS } from '../constants';
import { RANKS } from '../constants/gameConfig';

// Constants
export const QUEST_DURATION = GAME_CONSTANTS.QUEST_DURATION;

// Format time remaining as HH:MM:SS
export const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// Calculate progress percentage based on time remaining
export const calculateProgress = (timeRemaining: number, questStarted: boolean): number => {
  if (!questStarted && timeRemaining === 0) return 100;
  if (!questStarted) return 0;
  const elapsed = QUEST_DURATION - timeRemaining;
  return Math.min(100, Math.max(0, (elapsed / QUEST_DURATION) * 100));
};

// Reset quest timer to full duration
export const resetQuestTimer = (): number => QUEST_DURATION;

// XP utility functions
export function getXP() {
  const xp = localStorage.getItem('user_xp');
  return xp ? parseInt(xp, 10) : 0;
}

export function setXP(amount: number) {
  localStorage.setItem('user_xp', amount.toString());
}

export function addXP(amount: number) {
  const current = getXP();
  const next = current + amount;
  setXP(next);
  return next;
}

// Get current level based on XP
export function getCurrentLevel(): number {
  const xp = getXP();
  const currentRank = RANKS.slice().reverse().find(r => xp >= r.xp) || RANKS[0];
  return currentRank.level;
}

// Check if a game is unlocked based on required XP
export function isGameUnlocked(requiredXP: number): boolean {
  const currentXP = getXP();
  return currentXP >= requiredXP;
} 